import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import "./company.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import AddIcon from "@mui/icons-material/Add";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import { fetchCompany, removeCompany } from "../../store/slices/thunk";
import { FaEye } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { getTenantConfigFromStorage } from "../../helpers/tenantConfig";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const CompaniesListing = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllCompany, setAllCompany] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);

  const handleView = (id: string) => {
    navigate(`/viewcomanydetail/${id}`);
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [getCurrentUser, setCurrentUser] = useState<any>(null);
  const tenantConfig = getTenantConfigFromStorage();
  const isCompanyTenant = tenantConfig.mode === "company";
  const listingLabel = tenantConfig.labels.school;
  const addRoute = isCompanyTenant ? "/add-new-company" : "/add-new-school";
  const editBaseRoute = isCompanyTenant ? "/edit-new-company" : "/edit-new-school";

  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllCompany);

  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(
          fetchCompany(page, ITEMS_PER_PAGE, search, status)
        );
        if (
          response &&
          response?.data &&
          response?.data?.data &&
          response?.data?.data?.length &&
          response?.isSuccess
        ) {
          setAllCompany(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
        } else {
          setAllCompany([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.log(getAllCompany);
        setAllCompany([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false);
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [search, page, dispatch, status]);

  const gotoEdit = (id: string) => {
    navigate(`${editBaseRoute}/${id}`);
  };
    useEffect(() => {
      const fetchUser = async () => {
          const userData = localStorage.getItem("user");
        if (userData) {
          setCurrentUser(JSON.parse(userData));
        }
      };
      fetchUser();
    }, []);
  const handledeleteCompany = async (id: string) => {
    const response = await dispatch(removeCompany(id));
    if (response && response.isSuccess) {
      const newCustomer = getAllCompany.filter((item: any) => item._id !== id);
      setAllCompany(newCustomer);
    }
  };
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handledeleteCompany(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
  const navigateToaddcustomer = () => {
    navigate(addRoute);
  };
  return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="school-header">
        <div className="d-flex flex-column">
          <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
            {listingLabel} Management
          </h2>
          <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
            {`Manage ${listingLabel.toLowerCase()} info and branches`}
          </p>
        </div>
                                              {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (
        <button className="add-school-btn" onClick={navigateToaddcustomer}>
          <AddIcon />
          {`Add New ${listingLabel}`}
        </button>
                                              )}
      </div>

      <Paper sx={{ padding: 2, marginTop: "15px", borderRadius: "15px", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <div className="my-2 search-box justify-content-between align-items-baseline" style={{ flexShrink: 0 }}>
              <div className="search-wrapper">
                <IoSearchOutline className="search-icon" />
                <input
                  placeholder={`Type ${listingLabel} Name To Search`}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <select
                onChange={(e) => setStatus(e.target.value)}
                className="form-select"
                defaultValue=""
                style={{
                  width: "max-content",
                  height: "42px",
                  marginBottom: "15px",
                }}
                aria-label="Default select example"
              >
                <option value="">
                  All
                </option>
                <option value="active">Active</option>
                <option value="inActive">Inactive</option>
              </select>
            </div>
            <div style={{ flex: 1, overflow: "auto" }}>
              <Table className="table px-0">
                <TableHead className="th p-0">
                  <TableRow className="table-h-row">
                    <TableCell
                      className="px-1 py-2 text-start small text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      S.No
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start small text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      {listingLabel} Name
                      <FilterPopover column="companyName" filterType="text" currentValue={filters.companyName || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start small text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Contact Number
                      <FilterPopover column="contactNumber" filterType="text" currentValue={filters.contactNumber || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start small text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Total Parents
                      <FilterPopover column="customer" filterType="text" currentValue={filters.customer || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start small text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Status
                      <FilterPopover column="status" filterType="text" currentValue={filters.status || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start small text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody className="tb">
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {filteredData.map((company: any, index) => (
                      <TableRow key={index} className="t-row">
                        <TableCell> {(page - 1) * ITEMS_PER_PAGE + index + 1}</TableCell>
                        <TableCell>{company?.companyName}</TableCell>
                        <TableCell>{company?.contactNumber}</TableCell>
                        {/* <TableCell>{customer.mobile || "--"}</TableCell> */}
                        <TableCell>{company?.customer?.length || 0}</TableCell>

                        {/* <TableCell>
                          <span title={company.schoolLocation?.streetAddress}>
                            {company.schoolLocation?.streetAddress
                              ? company.schoolLocation.streetAddress.length > 10
                                ? company.schoolLocation.streetAddress.slice(
                                    0,
                                    25
                                  ) + "..."
                                : company.schoolLocation.streetAddress
                              : "--"}
                          </span>
                        </TableCell> */}

                        {/* <TableCell>{customer.code || "--"}</TableCell> */}
                        {/* <TableCell>
                          <Button
                            variant="contained"
                            endIcon={<SendIcon style={{ fontSize: "15px" }} />}
                            style={{
                              width: "120px",
                              height: "auto",
                              background: "#4285F4",
                              color: "#fff",
                              fontWeight: "500",
                              fontSize: "13px",
                              borderRadius: "12px",
                              textTransform: "none",
                            }}
                            component="a"
                            href={customer.whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Send Code
                          </Button>

                        </TableCell> */}
                        <TableCell>
                          {/* <Chip label={customer.driver || '--'} color="success" size="small" /> */}
                          <Chip
                            style={{
                              display: "inline-flex",
                              padding: "0.25rem 0.5rem",
                              fontSize: "0.75rem",
                              lineHeight: "1rem",
                              fontWeight: 600,
                              borderRadius: "9999px",
                              backgroundColor: "#D1FAE5",
                              color: "#065F46",
                            }}
                            label={company?.status || "--"}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton className="icon-btn">
                            <FaEye
                              className="icons"
                              onClick={() => handleView(company._id)}
                            />
                          </IconButton>
                                                              {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (
                          <IconButton className="icon-btn">
                            <EditIcon
                              onClick={() => gotoEdit(company._id)}
                              style={{ color: "primary" }}
                              className="icons"
                            />
                          </IconButton>
                                                              )}
                                                                                                    {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (
                          <IconButton className="icon-btn-red">
                            <MdDelete
                              onClick={() => handleDeleteClick(company._id)}
                              style={{ color: "red" }}
                              className="icons"
                            />
                          </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    <ConfirmDialog
                      open={openDialog}
                      onClose={() => setOpenDialog(false)}
                      onConfirm={confirmDelete}
                    />

                    {filteredData.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No Company Found.
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}
                </TableBody>
              </Table>
            </div>
          </div>
          <nav style={{ flexShrink: 0 }}>
            <ul className="pagination  mt-3 justify-content-center">
              <li className={`page-item ${page === 1 && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"}`}
                >
                  <button className="page-link" onClick={() => setPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}

              {pageCount > 5 && (
                <>
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() => setPage(pageCount)}
                    >
                      {pageCount}
                    </button>
                  </li>
                </>
              )}

              <li className={`page-item ${page === pageCount && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
      </Paper>
      </div>
  );
};

export default CompaniesListing;

